module.exports = __webpack_public_path__ + "static/img/defaultImage2.e4ddfa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/defaultImage2.png
// module id = 1BlI
// module chunks = 1